import axios from 'axios'
// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.headers['X-App-Version'] = '1.0'
    return config
  },
  error => {
    // do something with request error
    //   console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === '500') {
      // alert('服务器错误')
      console.log('error')
    } else if (res.code !== '100') {
      // alert(res.msg)
      // console.log('error')
      // return res
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      if (response.headers.token) {
        localStorage.setItem('token', response.headers.token)
      }
      return res
    }
  },
  error => {
    // Toast.fail('网络异常')
    // alert('网络异常')
    //  console.log('error')
    //  console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/http.js